import { useState } from 'react';
import { useNominatim, parseNominatimAddress } from '../hooks/useNominatim.js';
import Spinner from './Spinner.jsx';

function StaticMap({ lat, lon }) {
  if (!lat || !lon) return null;
  const src = `https://staticmap.openstreetmap.de/staticmap.php?center=${lat},${lon}&zoom=16&size=400x130&markers=${lat},${lon},red`;
  return (
    <div className="rounded-md overflow-hidden border border-border mt-2">
      <img
        src={src}
        alt="Mapa de la dirección"
        className="w-full h-32 object-cover bg-bg-elevated"
        onError={(e) => { e.target.style.display = 'none'; }}
      />
      <div className="px-2 py-1 text-xs text-slate-500 font-mono bg-bg-elevated">
        {lat}, {lon}
      </div>
    </div>
  );
}

export default function AddressSearch({ onSelect, lat, lon }) {
  const [query, setQuery] = useState('');
  const [showResults, setShowResults] = useState(false);
  const { results, loading, error, search, clear } = useNominatim();

  const handleChange = (e) => {
    setQuery(e.target.value);
    setShowResults(true);
    search(e.target.value);
  };

  const handleSelect = (result) => {
    const parsed = parseNominatimAddress(result);
    onSelect(parsed);
    setQuery(result.display_name.split(',').slice(0, 3).join(','));
    setShowResults(false);
    clear();
  };

  const handleClear = () => {
    setQuery('');
    setShowResults(false);
    clear();
  };

  return (
    <div className="space-y-2">
      <div className="relative">
        <label className="label">Buscar dirección</label>
        <div className="relative">
          <input
            className="input-base pr-8"
            placeholder="Ej: Av. Corrientes 1200, Buenos Aires..."
            value={query}
            onChange={handleChange}
            onFocus={() => results.length > 0 && setShowResults(true)}
          />
          {loading && (
            <div className="absolute right-2 top-1/2 -translate-y-1/2"><Spinner size="sm" /></div>
          )}
          {query && !loading && (
            <button onClick={handleClear} className="absolute right-2 top-1/2 -translate-y-1/2 text-slate-400 hover:text-white text-lg leading-none">×</button>
          )}
        </div>

        {showResults && (results.length > 0 || error) && (
          <div className="absolute z-20 left-0 right-0 top-full mt-1 bg-bg-surface border border-border rounded-lg shadow-xl">
            {error && <p className="text-xs text-amber-400 px-3 py-2">{error}</p>}
            {results.map((r) => (
              <button
                key={r.place_id}
                onClick={() => handleSelect(r)}
                className="w-full text-left px-3 py-2 text-sm text-slate-200 hover:bg-bg-elevated transition-colors border-b border-border last:border-0 truncate"
              >
                {r.display_name}
              </button>
            ))}
          </div>
        )}
      </div>

      {lat && lon && <StaticMap lat={lat} lon={lon} />}

      <p className="text-xs text-slate-500">
        Seleccioná un resultado para autocompletar los campos. Podés editar manualmente después.
      </p>
    </div>
  );
}
